import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/')({
  loader: async ({ params: { org, loopId } }) => {
    // redirect to dashboard route by default
    throw redirect({
      to: '/org/$org/loop/$loopId/dashboard',
      params: { org, loopId },
      replace: true,
    });
  },
});
